































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import { FamilyReport } from '@/interfaces/Models';
import { Debounce } from 'lodash-decorators';
import { Action, Getter } from 'vuex-class';
import FamilyReportDialog from '@/components/dashboard/shared/components/FamilyReportDialog.vue';

@Component({
  components: {
    FamilyReportDialog,
  },
})
export default class FamilyReportTable extends Vue {
  public familyReport: FamilyReport = {
    id: 0,

    babysitter: null,
    family: null,

    meal_notes: '',
    breakfast: false,
    morning_snack: false,
    lunch: false,
    afternoon_snack: false,
    dinner: false,
    evening_snack: false,

    activity_notes: '',
    free_play: false,
    crafts: false,
    story_time: false,
    tv_movies: false,
    outside: false,
    field_trip: false,

    rest_notes: '',
    naps: false,
    bedtime: false,

    learning_notes: '',
    new_words: false,
    skills: false,
    behaviors: false,

    family_notes: '',
  };

  public sessionReport: any = {
    family_report: this.familyReport,
  };

  public dialog = false;

  get headersLocalized(): any[] {
    return [
      {
        text: this.$t('table_headers.sessions.family'),
        value: 'family.family_name',
      },
      {
        text: this.$t('table_headers.sessions.babysitter'),
        value: 'babysitter.full_name',
      },
      {
        text: this.$t('table_headers.sessions.id'),
        value: 'session_report.session_id',
      },
      {
        text: this.$t('table_headers.shared.created_at'),
        value: 'created_at',
      },
      {
        text: this.$t('table_headers.shared.updated_at'),
        value: 'updated_at',
      },
      {
        text: this.$t('table_headers.shared.actions'),
        value: 'actions',
        align: 'end',
      },
    ];
  }
  public plans = [
    {
      id: 1,
      name: 'pay as you go',
    },
    {
      id: 2,
      name: 'bronze',
    },
    {
      id: 3,
      name: 'silver',
    },
    {
      id: 4,
      name: 'gold',
    },
    {
      id: 5,
      name: 'platinum',
    },
  ];

  @Watch('family')
  @Watch('babysitter')
  @Watch('itemsPerPage')
  @Debounce(500)
  onFilterValueChange() {
    this.currentPage = 1;
    this.fetchFamilyReports();
  }

  @Watch('currentPage')
  onPageChange() {
    if (this.$vuetify.breakpoint.mobile) {
      this.$vuetify.goTo(0);
    }
    this.fetchFamilyReports();
  }

  @Action('familyReports/setFamily') setFamily: any;
  @Getter('familyReports/family') familyState: any;
  public get family(): string {
    return this.familyState;
  }

  public set family(family: string) {
    this.setFamily(family);
  }

  @Action('familyReports/setBabysitter') setBabysitter: any;
  @Getter('familyReports/babysitter') babysitterState: any;
  public get babysitter(): string {
    return this.babysitterState;
  }

  public set babysitter(babysitter: string) {
    this.setBabysitter(babysitter);
  }

  @Action('familyReports/setCurrentPage') setCurrentPage: any;
  @Getter('familyReports/currentPage') currentPageState: any;
  public get currentPage(): number {
    return this.currentPageState;
  }

  public set currentPage(page: number) {
    this.setCurrentPage(page);
  }

  @Action('familyReports/setItemsPerPage') setItemsPerPage: any;
  @Getter('familyReports/itemsPerPage') itemsPerPageState: any;
  public get itemsPerPage(): number {
    return this.itemsPerPageState;
  }

  public set itemsPerPage(itemsPerPage: number) {
    this.setItemsPerPage(itemsPerPage);
  }

  @Action('familyReports/fetchFamilyReports') fetchFamilyReports: any;
  @Getter('familyReports/reports') reports: any;

  @Action('familyReports/setFamiliesLoading') setFamiliesLoading: any;
  @Getter('familyReports/familiesLoading') familiesLoadingState: any;

  public get familiesLoading(): boolean {
    return this.familiesLoadingState;
  }

  public set familiesLoading(value: boolean) {
    this.setFamiliesLoading(value);
  }

  @Getter('familyReports/total') total: any;
  @Action('familyReports/clearPayload') clearFilters: any;

  public showReport(report: FamilyReport) {
    this.dialog = true;
    this.familyReport = { ...report };
  }

  public fetchReportPdf(report: FamilyReport) {
    axios
      .post(
        api.path('v1.admin.familyReports.toPDF', { id: report.id }),
        {},
        { responseType: 'blob' }
      )
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: 'application/pdf' })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Document');
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
  }

  public async mounted() {
    await this.fetchFamilyReports();
  }
}
